(() => {
  'use strict';
  const drawer = document.getElementById('drawer-menu');
  const overlay = document.getElementById('drawer-overlay');
  const trigger = document.getElementById('hamburger-btn');
  const search = document.getElementById('search-overlay');
  const searchTrigger = document.getElementById('search-trigger');
  let previousFocus;
  function setDrawer(open) {
    if (!drawer) return;
    if (open) previousFocus = document.activeElement;
    drawer.classList.toggle('is-open', open);
    drawer.inert = !open;
    drawer.setAttribute('aria-hidden', String(!open));
    overlay?.classList.toggle('is-open', open);
    trigger?.classList.toggle('is-open', open);
    trigger?.setAttribute('aria-expanded', String(open));
    document.body.style.overflow = open ? 'hidden' : '';
    if (open) drawer.querySelector('button, a')?.focus();
    else previousFocus?.focus();
  }
  function setSearch(open) {
    if (!search) return;
    search.classList.toggle('is-open', open);
    search.inert = !open;
    search.setAttribute('aria-hidden', String(!open));
    searchTrigger?.setAttribute('aria-expanded', String(open));
    if (open) search.querySelector('input')?.focus();
    else searchTrigger?.focus();
  }
  if (drawer) { drawer.inert = true; drawer.setAttribute('aria-hidden','true'); }
  if (search) search.inert = true;
  trigger?.addEventListener('click', () => setDrawer(true));
  overlay?.addEventListener('click', () => setDrawer(false));
  document.getElementById('drawer-close')?.addEventListener('click', () => setDrawer(false));
  searchTrigger?.addEventListener('click', () => setSearch(!search?.classList.contains('is-open')));
  document.getElementById('search-close')?.addEventListener('click', () => setSearch(false));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      if (drawer?.classList.contains('is-open')) setDrawer(false);
      if (search?.classList.contains('is-open')) setSearch(false);
    }
    if (event.key === 'Tab' && drawer?.classList.contains('is-open')) {
      const nodes = [...drawer.querySelectorAll('button,a,input,select')].filter(el => !el.disabled && el.getClientRects().length);
      const first=nodes[0], last=nodes.at(-1);
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    }
  });
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-quantity-step]');
    if (!button) return;
    const input = button.parentElement.querySelector('input[type="number"]');
    if (!input) return;
    input.value = Math.max(Number(input.min || 0), (Number(input.value) || 0) + Number(button.dataset.quantityStep));
    input.dispatchEvent(new Event('change', {bubbles:true}));
  });
  let cartTimer;
  document.addEventListener('biopa:cart-refresh-start',()=>clearTimeout(cartTimer));
  document.addEventListener('change',event=>{
    const form=event.target.closest('#bp-cart-form');
    if(!form || event.target.name!=='updates[]' || form.inert)return;
    clearTimeout(cartTimer);
    cartTimer=setTimeout(()=>{if(form.isConnected&&!form.inert)form.requestSubmit(form.querySelector('#bp-cart-update'));},400);
  });
  document.addEventListener('submit',event=>{if(event.target.id==='bp-cart-form'){clearTimeout(cartTimer);event.target.setAttribute('aria-busy','true');}});
  const variantSelect=document.querySelector('[data-product-variant]');
  variantSelect?.addEventListener('change', () => {
    const option=variantSelect.selectedOptions[0];
    const submit=document.querySelector('[data-product-submit]');
    const available=option.dataset.available==='true';
    document.querySelector('[data-product-price]').textContent=option.dataset.price;
    submit.disabled=!available;
    submit.textContent=available?submit.dataset.addLabel:submit.dataset.soldLabel;
  });
  function initBundles(scope=document) {
    scope.querySelectorAll('[data-bundle-form]').forEach(form => {
      if(form.dataset.initialized) return;
      form.dataset.initialized='true';
      const section=form.closest('.bp-bundles');
      section.querySelectorAll('[data-bundle-count]').forEach(button => button.addEventListener('click',()=>{
        const count=Number(button.dataset.bundleCount);
        section.querySelectorAll('[data-bundle-count]').forEach(other=>{const active=other===button;other.classList.toggle('is-selected',active);other.setAttribute('aria-pressed',String(active));});
        form.querySelectorAll('[data-bundle-slot]').forEach(slot=>{const active=Number(slot.dataset.bundleSlot)<=count;slot.hidden=!active;slot.querySelector('select').disabled=!active;});
      }));
      form.addEventListener('submit',async event=>{
        event.preventDefault();
        const button=form.querySelector('button[type="submit"]');
        if(button.disabled) return;
        const status=form.querySelector('[data-bundle-status]');
        const label=button.textContent;
        button.disabled=true;button.textContent=form.dataset.loading;button.classList.add('is-loading');button.setAttribute('aria-busy','true');status.textContent='';
        const counts=new Map();
        form.querySelectorAll('select:not(:disabled)').forEach(select=>counts.set(select.value,(counts.get(select.value)||0)+1));
        try {
          const response=await fetch(form.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[...counts].map(([id,quantity])=>({id,quantity}))})});
          const result=await response.json();
          if(!response.ok || result.status) throw new Error(result.description || form.dataset.error);
          button.classList.remove('is-loading');button.removeAttribute('aria-busy');button.classList.add('is-added');button.textContent=window.biopaMotionLabels?.added || label;document.dispatchEvent(new CustomEvent('biopa:added',{detail:result}));setTimeout(()=>window.location.assign(form.dataset.cartUrl),1100);
        } catch(error) {status.textContent=error.message || form.dataset.error;button.disabled=false;button.textContent=label;button.classList.remove('is-loading');button.removeAttribute('aria-busy');}
      });
    });
  }
  initBundles();
  document.addEventListener('shopify:section:load',event=>initBundles(event.target));
})();
